import { render, staticRenderFns } from "./ApplicationHistory.vue?vue&type=template&id=4c809c74&scoped=true&"
import script from "./ApplicationHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c809c74",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c809c74')) {
      api.createRecord('4c809c74', component.options)
    } else {
      api.reload('4c809c74', component.options)
    }
    module.hot.accept("./ApplicationHistory.vue?vue&type=template&id=4c809c74&scoped=true&", function () {
      api.rerender('4c809c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/views/ApplicationHistory.vue"
export default component.exports